import React, { useEffect, useState } from "react";
import ListTable from "../../components/listTable/ListTable";
import { Header, Heading, MainContainer } from "../../globalStyles";
import { ListModule } from "./tasksListStyles";
import { useParams } from "react-router-dom";
import { tasksData } from "../../redux/apiCalls";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from 'react-toastify'
import BarLoader from "react-spinners/BarLoader";
import Loader from "../../components/loader/Loader";
const TasksList = () => {
  const [isfound, setIsfound] = useState(false);
  const dispatch = useDispatch();
  let { type } = useParams();

  const { isFetching, error, DataList } = useSelector((state) => state.tasks);

  useEffect(() => {
    tasksData(dispatch, type, sessionStorage.getItem("accessJWT"));
  }, []);

  const tasksColumns = [
    {
      field: "id",
      headerName: "ID",
      align: "center",
      headerAlign: "center",
      width: 150,
      hide: true,
    },

    {
      field: "task_id",
      headerName: "TASK NO.",
      align: "center",
      headerAlign: "center",
      width: 150,
      renderCell: (params) => {
        return (
          <div
            style={{
              color: "#614e20ff",
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {params.row.task_id}
          </div>
        );
      },
    },

    {
      field: "response",
      headerName: "RESPONSE",
      align: "center",
      headerAlign: "center",
      width: 200,
      editable: true,
    },
    {
      field: "date_assignment",
      headerName: "DATE OF SERVICE",
      align: "center",
      headerAlign: "center",
      width: 200,
      editable: true,
    },
    {
      field: "pick_up_time",
      headerName: "PICK UP TIME",
      type: "number",
      align: "center",
      headerAlign: "center",
      width: 180,
    },
    {
      field: "member_main_account",
      headerName: "CLIENT NAME",
      align: "center",
      headerAlign: "center",
      sortable: false,
      width: 180,
    },
    {
      field: "task_status",
      headerName: "STATUS",
      sortable: false,
      align: "center",
      headerAlign: "center",
      width: 180,
    },
    {
      field: "action",
      headerName: "ACTION",
      sortable: false,
      align: "center",
      headerAlign: "center",
      width: 180,
      renderCell: (params) => {
        return (
          <>
            {type === "opened_tasks" ? (
              <form action="">
                <select style={{ height: "25px" }} id="action">
                  <option selected>
                    Select Response
                  </option>
                  <option value="accept">Accept</option>
                  <option value="reject">Reject</option>
                </select>
              </form>
            ) : (
              <span></span>
            )}
          </>
        );
      },
    },
  ];

  const newRows = DataList?.map((data) => {
    return {
      id: data.id,
      task_id: data.task_id,
      response: type === "opened_tasks" ? "Open" : " Assigned",
      date_assignment: new Date(data.date_assignment).toDateString(),
      pick_up_time: data.pick_up_time,
      member_main_account: data.member_main_account,
      task_status: data.task_status,
      action: "",
    };
  });

  return (
    <MainContainer>
      <ListModule>
        <Header>
          <Heading>{type.toUpperCase()}</Heading>
        </Header>
        {isFetching? <Loader isFetching={isFetching} />:(<>
        {DataList && <ListTable rows={newRows} columns={tasksColumns} />}</> )}
      </ListModule>
      <ToastContainer position="bottom-right" newestOnTop />
    </MainContainer>
  );
};

export default TasksList;
